<div class="grid rea-row">
	<div class="col-12 md:col-6">
		<label class="rea-label">NIF/CIF</label>
		<p class="rea-value">{{ nif }}</p>
	</div>

	<div class="col-12 md:col-6">
		<label class="rea-label">Código REA</label>
		<p class="rea-value">{{ codigoRea || 'Pendiente de confirmar' }}</p>
	</div>
</div>
